module.exports = __webpack_public_path__ + "static/img/23.3c63317c.png";